import { http } from '../http/http'

export class r360Api {
    static BASE_URL: string = process.env.SMARTLY_BASE_URL_BE
    static BASE_PERMISSIONS_URL: string =
        r360Api.BASE_URL + '/profileapi/permissions'

    static headersObj = {
        headers: {
            'Accept-Language': '',
        },
        timeout: 180000,
    }

    static GetActions = () => {
        return http.get<any>(r360Api.BASE_PERMISSIONS_URL, r360Api.headersObj)
    }
}
